// Greek + English UI translations. Greek = default.
export const DICT = {
  el: {
    app_name: "ΙΧΝΟΔΙΚΗΣ",
    app_tagline: "Επιχειρησιακό κέντρο ποινικής υπεράσπισης",
    login: "Σύνδεση", logout: "Αποσύνδεση", register: "Εγγραφή",
    email: "Email", password: "Κωδικός", name: "Ονοματεπώνυμο",
    welcome_back: "Καλώς ήρθατε ξανά", sign_in_subtitle: "Συνδεθείτε στο επιχειρησιακό σας κέντρο",
    no_account: "Δεν έχετε λογαριασμό;", has_account: "Έχετε ήδη λογαριασμό;",
    create_account: "Δημιουργία λογαριασμού",
    cases: "Υποθέσεις", new_case: "Νέα Υπόθεση", select_case: "Επιλέξτε υπόθεση",
    // Nav (per design guidelines)
    dashboard: "Πίνακας Ελέγχου",
    case_overview: "Επισκόπηση Υπόθεσης",
    procedure: "Δικονομική Πορεία",
    timeline: "Χρονολόγιο Γεγονότων",
    witnesses: "Μάρτυρες",
    evidence: "Αποδεικτικά Στοιχεία",
    digital_evidence: "Ψηφιακά Αποδεικτικά",
    forensics: "Πραγματογνωμοσύνες",
    case_law: "Νομολογία",
    defense_theory: "Υπερασπιστική Γραμμή",
    hearings: "Δικάσιμοι",
    tasks: "Εκκρεμότητες",
    ai_prompts: "Εντολές AI",
    reports: "Αναφορές / Παραδοτέα",
    courtroom: "Courtroom Mode",
    settings: "Ρυθμίσεις",
    // Dashboard
    client: "Εντολέας", court: "Δικαστήριο", next_hearing: "Επόμενη Δικάσιμος",
    status: "Κατάσταση", urgency: "Επείγον", risk_score: "Δείκτης Κινδύνου",
    defense_readiness: "Ετοιμότητα Υπεράσπισης", total_evidence: "Σύνολο Αποδεικτικών",
    total_witnesses: "Σύνολο Μαρτύρων", pending_tasks: "Εκκρεμότητες",
    upcoming_deadlines: "Επερχόμενες Προθεσμίες",
    quick_actions: "Γρήγορες Ενέργειες",
    add_document: "Προσθήκη Εγγράφου", add_witness: "Προσθήκη Μάρτυρα",
    add_event: "Προσθήκη Γεγονότος", generate_timeline: "Δημιουργία Χρονολογίου",
    generate_trial_prep: "Σύνοψη Προετοιμασίας Δίκης",
    generate_cross_exam: "Ερωτήσεις Αντεξέτασης",
    upcoming_hearings: "Επερχόμενες Δικάσιμοι",
    recent_evidence: "Πρόσφατα Αποδεικτικά",
    risky_witnesses: "Μάρτυρες Κινδύνου",
    ai_insights: "Πρόσφατες Αναλύσεις AI",
    critical_issues: "Κρίσιμα Ανοιχτά Ζητήματα",
    // Common
    save: "Αποθήκευση", cancel: "Ακύρωση", delete: "Διαγραφή", edit: "Επεξεργασία",
    add: "Προσθήκη", search: "Αναζήτηση", filter: "Φίλτρα",
    title: "Τίτλος", description: "Περιγραφή", date: "Ημερομηνία",
    time: "Ώρα", notes: "Σημειώσεις", source: "Πηγή", relevance: "Συνάφεια",
    type: "Τύπος", role: "Ρόλος", importance: "Σημαντικότητα",
    priority: "Προτεραιότητα", due: "Προθεσμία", assigned: "Ανατέθηκε σε",
    tags: "Ετικέτες", actions: "Ενέργειες", confirm: "Επιβεβαίωση",
    generate: "Δημιουργία", export: "Εξαγωγή", upload: "Μεταφόρτωση",
    download: "Λήψη", view: "Προβολή", close: "Κλείσιμο",
    saved: "Αποθηκεύτηκε", deleted: "Διαγράφηκε", created: "Δημιουργήθηκε",
    empty_state: "Δεν υπάρχουν δεδομένα ακόμα",
    loading: "Φόρτωση...",
    // Witness strength
    strong: "Ισχυρός", neutral: "Ουδέτερος", risky: "Επισφαλής", hostile: "Εχθρικός",
    witness_strength: "Δείκτης Μάρτυρα",
    // Evidence
    admissibility: "Παραδεκτό",
    chain_of_custody: "Αλυσίδα Φύλαξης",
    valid: "Έγκυρο", contested: "Αμφισβητούμενο", inadmissible: "Απαράδεκτο",
    defense: "Υπεράσπιση", prosecution: "Κατηγορία",
    impact_score: "Δείκτης Επίδρασης",
    // Reports
    generate_report: "Δημιουργία Αναφοράς",
    master_memo: "Master Υπόμνημα Υπόθεσης",
    trial_prep_summary: "Σύνοψη Προετοιμασίας Δίκης",
    witness_analysis: "Ανάλυση Μαρτύρων",
    evidence_matrix: "Μήτρα Αποδεικτικών",
    cross_exam_plan: "Σχέδιο Αντεξέτασης",
    hearing_brief: "Υπόμνημα Δικασίμου",
    appeal_memo: "Υπόμνημα Λόγων Έφεσης",
    defense_memo: "Υπόμνημα Υπερασπιστικής Στρατηγικής",
    // AI prompts
    case_summary: "Σύνοψη Υπόθεσης",
    witness_contradictions: "Αντιφάσεις Μαρτύρων",
    cross_examination: "Αντεξέταση",
    prosecution_weaknesses: "Αδυναμίες Κατηγορίας",
    expert_analysis: "Ανάλυση Πραγματογνωμοσύνης",
    trial_preparation: "Προετοιμασία Δίκης",
    appeal_grounds: "Λόγοι Έφεσης",
    hearing_prep: "Προετοιμασία Δικασίμου",
    run_prompt: "Εκτέλεση Εντολής",
    select_model: "Μοντέλο AI",
    custom_instructions: "Επιπλέον οδηγίες (προαιρετικά)",
    ai_confidence: "Δείκτης Εμπιστοσύνης",
    // Onboarding
    onboarding_title: "Δημιουργία νέας υπόθεσης",
    step_of: "Βήμα {n} από {total}",
    next: "Επόμενο", back: "Πίσω", finish: "Ολοκλήρωση",
    // Theme / lang
    dark_mode: "Σκούρο", light_mode: "Φωτεινό", language: "Γλώσσα",
    profile: "Προφίλ",
    // Settings
    appearance: "Εμφάνιση", account: "Λογαριασμός",
    // Misc
    audit_log: "Audit Log",
    billing: "Συνδρομή",
    forgot_password: "Ξεχάσατε τον κωδικό;",
    app_name: "ΙΧΝΟΔΙΚΗΣ",
    app_tagline: "Criminal defense operating room",
    login: "Sign in", logout: "Sign out", register: "Register",
    email: "Email", password: "Password", name: "Full name",
    welcome_back: "Welcome back", sign_in_subtitle: "Sign in to your command center",
    no_account: "No account?", has_account: "Already have an account?",
    create_account: "Create account",
    cases: "Cases", new_case: "New Case", select_case: "Select a case",
    dashboard: "Dashboard", case_overview: "Case Overview", procedure: "Procedure",
    timeline: "Facts & Timeline", witnesses: "Witnesses", evidence: "Evidence",
    digital_evidence: "Digital Evidence", forensics: "Forensics / Experts",
    case_law: "Case Law", defense_theory: "Defense Theory",
    hearings: "Hearings", tasks: "Tasks", ai_prompts: "AI Prompts",
    reports: "Reports / Outputs", courtroom: "Courtroom Mode", settings: "Settings",
    client: "Client", court: "Court", next_hearing: "Next Hearing",
    status: "Status", urgency: "Urgency", risk_score: "Risk Score",
    defense_readiness: "Defense Readiness", total_evidence: "Total Evidence",
    total_witnesses: "Total Witnesses", pending_tasks: "Pending Tasks",
    upcoming_deadlines: "Upcoming Deadlines", quick_actions: "Quick Actions",
    add_document: "Add Document", add_witness: "Add Witness",
    add_event: "Add Event", generate_timeline: "Generate Timeline",
    generate_trial_prep: "Trial Prep Summary",
    generate_cross_exam: "Cross-Examination Questions",
    upcoming_hearings: "Upcoming Hearings", recent_evidence: "Recent Evidence",
    risky_witnesses: "Risky Witnesses", ai_insights: "Recent AI Insights",
    critical_issues: "Critical Open Issues",
    save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit",
    add: "Add", search: "Search", filter: "Filter",
    title: "Title", description: "Description", date: "Date",
    time: "Time", notes: "Notes", source: "Source", relevance: "Relevance",
    type: "Type", role: "Role", importance: "Importance",
    priority: "Priority", due: "Due", assigned: "Assigned",
    tags: "Tags", actions: "Actions", confirm: "Confirm",
    generate: "Generate", export: "Export", upload: "Upload",
    download: "Download", view: "View", close: "Close",
    saved: "Saved", deleted: "Deleted", created: "Created",
    empty_state: "No data yet",
    loading: "Loading...",
    strong: "Strong", neutral: "Neutral", risky: "Risky", hostile: "Hostile",
    witness_strength: "Witness Strength",
    admissibility: "Admissibility", chain_of_custody: "Chain of Custody",
    valid: "Valid", contested: "Contested", inadmissible: "Inadmissible",
    defense: "Defense", prosecution: "Prosecution",
    impact_score: "Impact Score",
    generate_report: "Generate Report",
    master_memo: "Master Case Memo",
    trial_prep_summary: "Trial Preparation Summary",
    witness_analysis: "Witness Analysis Report",
    evidence_matrix: "Evidence Matrix",
    cross_exam_plan: "Cross-Examination Plan",
    hearing_brief: "Hearing Brief",
    appeal_memo: "Appeal Issues Memo",
    defense_memo: "Defense Strategy Memo",
    case_summary: "Case Summary",
    witness_contradictions: "Witness Contradictions",
    cross_examination: "Cross-Examination",
    prosecution_weaknesses: "Prosecution Weaknesses",
    expert_analysis: "Expert Report Analysis",
    trial_preparation: "Trial Preparation",
    appeal_grounds: "Appeal Grounds",
    hearing_prep: "Hearing Preparation",
    run_prompt: "Run Prompt",
    select_model: "AI Model",
    custom_instructions: "Additional instructions (optional)",
    ai_confidence: "Confidence",
    onboarding_title: "Create new case",
    step_of: "Step {n} of {total}",
    next: "Next", back: "Back", finish: "Finish",
    dark_mode: "Dark", light_mode: "Light", language: "Language",
    profile: "Profile",
    appearance: "Appearance", account: "Account",
    high: "High", medium: "Medium", low: "Low", critical: "Critical",
    todo: "To do", in_progress: "In progress", done: "Done",
    audit_log: "Audit Log", billing: "Subscription",
    forgot_password: "Forgot password?",
  },
};

export function t(lang, key, vars) {
  const v = DICT[lang]?.[key] ?? DICT.el[key] ?? key;
  if (!vars) return v;
  return Object.entries(vars).reduce((acc, [k, val]) => acc.replace(`{${k}}`, val), v);
}
